<template>
	<v-container>
		<v-form ref="formEditUser">
			<div v-if="rightsToPrefill">
				<h2 class="edit-user-spectial-rights">{{ txt.editSpectialRights }}</h2>
				<p> {{ txt.report }}: <i>{{ rightsToPrefill[0].application_name }}</i> - {{ txt.installation}}: <i>{{ rightsToPrefill[0].mandator_description }}</i></p>
				<p>{{ txt.user }}: <strong>{{ rightsToPrefill[0].firstname }} {{ rightsToPrefill[0].lastname }}</strong></p>	
			</div>

			<div>
				<v-row>
					<v-col md="12">
						<autocomplete-objects
							:key="serviceproviderKey"
							:items="serviceproviderList"
							label="Restriction on serviceprovider:"
							:model.sync="selectedServiceprovider"
							:item-text="item => item.serviceprovider_name +' - ID: '+ item.id"
							:search.sync="searchServiceprovider"
							:disabled="loading"
						/>
					</v-col>
					<v-col md="12">
						<autocomplete-objects
							:key="productKey"
							:items="productList"
							label="Restriction on product:"
							:model.sync="selectedProduct"
							:item-text="item => 'Name: ' + item.value +' - SKU: ' + item.sku + ' - ID: '+ item.entity_id"
							:search.sync="searchProduct"
							:disabled="loading"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col md="12">
						<autocomplete-objects
							:key="regionKey"
							:items="regionList"
							label="Restriction on region:"
							:model.sync="selectedRegion"
							:item-text="item => item.region_name +' - ID: '+ item.id"
							:search.sync="searchRegion"
							:disabled="loading"
						/>
					</v-col>
					<v-col md="12">
						<autocomplete-objects
							:key="salesChannelKey"
							:items="salesChannelList"
							label="Restriction on sales channel:"
							:model.sync="selectedSalesChannel"
							:item-text="item => item.name +' - ID: '+ item.website_id"
							:search.sync="searchSalesChannel"
							:disabled="loading"
						/>
					</v-col>
				</v-row>
				<v-row>
					<v-col md="12">
						<autocomplete-objects
							:key="resellerKey"
							:items="resellerList"
							label="Restriction on reseller:"
							:model.sync="selectedReseller"
							:item-text="item => item.username +' - ID: '+ item.id"
							:search.sync="searchReseller"
							:disabled="loading"
						/>
					</v-col>
				</v-row>
			</div>
		</v-form>
	</v-container>
</template>

<script>
import axios from 'axios'
import AutocompleteObjects from '../../vueBasics/AutocompleteObjects.vue'

export default {
	name: 'SpecialUserRights',
	props: {
		installation: { type: Object, required: true },
		application: { type: Object, required: true },
		selectedUser: { type: Object, required: true },
		specialRightsToggle: { type: Boolean, required: true, default: false } ,
		rightsToPrefill: { type: Array, required: false }
	},
	components: {
		AutocompleteObjects,
	},
	data() {
		return {
			loading: false,
			serviceproviderList: [],
			selectedServiceprovider: [],
			searchServiceprovider: null,
			productList: [],
			selectedProduct: [],
			searchProduct: null,
			regionList: [],
			selectedRegion: [],
			searchRegion: null,
			salesChannelList: [],
			selectedSalesChannel: [],
			searchSalesChannel: null,
			resellerList: [],
			selectedReseller: [],
			searchReseller: null,
			serviceproviderKey: 0,
			productKey: 0,
			salesChannelKey: 0,
			regionKey: 0,
			resellerKey: 0,
			txt: {
				editSpectialRights: 'Edit the rights for',
				report: 'Report',
				installation: 'Mandator',
				user: 'User',
			},
		}
	},
	methods: {
		async getInstallationInfo() {
			if (!this.installation || !this.installation.installation_id) return
			this.changeAndEmitLoading(true)
			try {
				const installationInfoRes = await axios.get(`${config.baseAPIurl}/user-manager/get-info-for-installation`, {
					params: {
						installation_id: this.installation.installation_id,
						metis_id: this.installation.metis_id,
					},
				})
				this.serviceproviderList = installationInfoRes.data.serviceProviders
				this.productList = installationInfoRes.data.products
				this.salesChannelList = installationInfoRes.data.salesChannels
				this.regionList = installationInfoRes.data.regions
				this.resellerList = installationInfoRes.data.resellers
			} catch (error) {
				console.log(error)
				this.alert.show = true
				this.loading = false
				this.alert.message = 'attributes could not be loaded'
			} finally {
				this.changeAndEmitLoading(false)
			}
		},
		changeAndEmitLoading(value){
			this.loading = value
			this.$emit('loadingChanged', value)
		},
		resetSpecialRightsLists() {
			this.$data.selectedServiceprovider = []
			this.$data.selectedProduct = []
			this.$data.selectedSalesChannel = []
			this.$data.selectedRegion = []
			this.$data.selectedReseller = []
		},
		async fetchAndPrefillRights(){
			await this.getInstallationInfo()
			await this.prefillRights()
		},
		async prefillRights(){
			if(!this.rightsToPrefill) return
			this.selectedServiceprovider = this.getObjectsWithMatchingIds(this.rightsToPrefill[0].serviceprovider_id, this.serviceproviderList)
			this.serviceproviderKey += 1
			const skuFilteredPrducts = this.getObjectsWithMatchingIds(this.rightsToPrefill[0].product_sku, this.productList, 'sku')
			const idFilteredProducts = this.getObjectsWithMatchingIds(this.rightsToPrefill[0].product_sku.map(id => parseInt(id, 10)), this.productList, 'entity_id')
			if (idFilteredProducts || skuFilteredPrducts) this.selectedProduct = idFilteredProducts || skuFilteredPrducts
			this.productKey += 1
			this.selectedSalesChannel = this.getObjectsWithMatchingIds(this.rightsToPrefill[0].website_id, this.salesChannelList, 'website_id')
			this.salesChannelKey += 1
			this.selectedRegion = this.getObjectsWithMatchingIds(this.rightsToPrefill[0].region_id, this.regionList)
			this.regionKey += 1
			this.selectedReseller = this.getObjectsWithMatchingIds(this.rightsToPrefill[0].reseller_id, this.resellerList)
			this.resellerKey += 1
		},
		getObjectsWithMatchingIds (ids, objects, key = 'id') {
			if(ids) {
				return objects.filter(obj => {
					return ids.includes(obj[key])
				})
			}
		},
	},
	watch: {
		installation: {
			handler(value){
				if( this.application && this.application != {} && value && value != {}) this.getInstallationInfo()
				else this.resetSpecialRightsLists()
			}
		},
		application: {
			handler(value){
				if( this.installation && this.installation != {} && value && value != {}) this.getInstallationInfo() 
				else this.resetSpecialRightsLists()
			}
		},
		dialogToggle: { 
			handler(value) { 
				if (value) this.getInstallationInfo()
			}
		},
		selectedServiceprovider: { handler(value) { this.$emit('serviceproviderChanged', value)} },
		selectedProduct: { handler(value) { this.$emit('productChanged', value)} },
		selectedRegion: { handler(value) { this.$emit('regionChanged', value)} },
		selectedSalesChannel: { handler(value) { this.$emit('salesChannelChanged', value)} },
		selectedReseller: { handler(value) { this.$emit('resellerChanged', value) } },
		specialRightsToggle: { handler(value) { if(value) this.fetchAndPrefillRights() }},
	},
	mounted() {
		this.fetchAndPrefillRights()
	}
}
</script>

<style lang="scss" scoped>

</style>
